export const LEAD_DEFAULT_PAGE_SIZE = 12;
// /customer-lead/leads has no search or filters, so the list is fetched once and filtered locally
export const LEAD_FETCH_PAGE_SIZE = 500;

// Same endpoints the mobile Customer Leads screens use (ahd-mobile/src/screens/Customer/Leads)
export const LEAD_ENDPOINTS = {
  listMy: "/customer-lead/leads",
  details: (id) => `/customer-lead/${id}`,
  create: "/customer-lead/add",
  edit: "/customer-lead/edit",
  remove: (id) => `/customer-lead/delete/${id}`,

  purposes: "/customer-lead-purpose/all",
  states: (countryId = 1) => `/admin/states/${countryId}`,
  cities: (stateId) => `/admin/cities/${stateId}`,

  notes: "/customer-lead/notes",
  addNote: "/customer-lead/note/add",
  editNote: "/customer-lead/note/edit",
  removeNote: (id) => `/customer-lead/note/delete/${id}`,
};

// Mirrors the backend CustomerLeadStatus enum. Mobile does not show or change the status; the web
// only displays it (and filters by it).
export const LEAD_STATUSES = [
  { value: "PENDING", label: "Pending", variant: "warning" },
  { value: "IN_REVIEW", label: "In Review", variant: "info" },
  { value: "INPROGRESS", label: "In Progress", variant: "primary" },
  { value: "COMPLETED", label: "Completed", variant: "success" },
  { value: "PAYOUT_DONE", label: "Payout Done", variant: "dark" },
];

export const MAX_DESCRIPTION_LENGTH = 2000;
